export default __webpack_public_path__ + "static/media/resume.8422be9d.svg";